/* eslint-disable no-console */
import { API } from 'aws-amplify';
import axios from 'axios';

export function getBookmarks(queryStringParameters:any)
{
	return API.get('feedsManagement', '/bookmark', { queryStringParameters });
}
export function getNewsFeeds(queryStringParameters:any)
{
	return API.get('feedsManagement', '/getFeed', { queryStringParameters });
}
export function getPendingApprovalFeeds(queryStringParameters:any)
{
	return API.get('feedsManagement', '/approval-list', { queryStringParameters });
}

export function updateFeedApprovalStatus(feedId: string, status: 'approved' | 'rejected', body:any)
{
	return API.put('feedsManagement', `/approval-list/${feedId}/status/${status}`, { body });
}
export function createBookmark(body:any, queryStringParameters:any)
{
	return API.post('feedsManagement', '/bookmark', { body, queryStringParameters });
}
export function deleteBookmark(path:any, queryStringParameters:any)
{
	return API.del('feedsManagement', `/bookmark/${path}`, { queryStringParameters });
}
export function fetchCompaniesByfeeds(queryStringParameters:any)
{
	return API.get('feedsManagement', 'getConnectionsByFeeds', { queryStringParameters });
}
export function getPopularFeeds(queryStringParameters:any)
{
	return API.get('feedsManagement', '/getFeedSuggestions', { queryStringParameters });
}
export function getLikedUsers(id, queryStringParameters:any)
{
	return API.get('feedsManagement', `/likes/${id}`, { queryStringParameters });
}
export function getFeedByCompanyId(id, queryStringParameters:any)
{
	return API.get('feedsManagement', `/getFeedByCompany/${id}`, { queryStringParameters });
}
export function getFeedById(id, queryStringParameters:any)
{
	return API.get('feedsManagement', `/getFeedById/${id}`, { queryStringParameters });
}
export function upatedFeedsAPI(body:any, queryStringParameters:any)
{
	return API.put('feedsManagement', '/updateFeed', { body, queryStringParameters });
}
export function repostFeedsAPI(body:any)
{
	return API.post('feedsManagement', '/repost', { body });
}
export function deleteFeedsAPI(queryStringParameters:any)
{
	return API.del('feedsManagement', '/deleteFeed', { queryStringParameters });
}
export function updateFeedsLike(body:any, queryStringParameters:any)
{
	return API.post('feedsManagement', '/like', { queryStringParameters, body });
}

// Feeds-Configuration

export function getFeedConfig(queryStringParameters:any)
{
	return API.get('userManagement', '/getConfiguration', { queryStringParameters });
}
export function updateFeedConfig(body:any)
{
	return API.post('userManagement', '/configurations', { body });
}
export function getFeedsAdminList(queryStringParameters:any)
{
	return API.get('userManagement', '/configurations/feed', { queryStringParameters });
}
export function getComments(path:any, queryStringParameters:any)
{
	return API.get('feedsManagement', `/comments/${path}`, { queryStringParameters });
}
export function createComment(body:any, queryStringParameters:any)
{
	return API.post('feedsManagement', '/comment', { body, queryStringParameters });
}
export function updateCmntAction(body)
{
	return API.put('feedsManagement', '/updateComment', { body });
}
export function updateCommentApi(body:any, queryStringParameters:any)
{
	return API.put('feedsManagement', '/updateComment', { body, queryStringParameters });
}
export function deleteCommentApi(path:any, queryStringParameters:any)
{
	return API.del('feedsManagement', `/comment/${path}`, { queryStringParameters });
}

export function createNewFeed(body:any)
{
	return API.post('feedsManagement', '/createFeed', { body });
}
export function getConnectionsByFeeds(queryStringParameters:any)
{
	return API.get('feedsManagement', '/getConnectionsByFeeds', { queryStringParameters });
}

export function submitPoll(body:any)
{
	return API.post('feedsManagement', '/submitPoll', { body });
}
export const getRelationsData = (queryStringParameters:any) =>
{
	return API.get('departments', '/getRelations', { queryStringParameters });
};
export function reportFeed(body:any, queryStringParameters:any)
{
	return API.post('feedsManagement', '/reportfeed', { queryStringParameters, body });
}
export const undoReportFeed = (body) =>
{
	return API.put('feedsManagement', '/undoReport', { body });
};
export const getIndustry = (queryStringParameters:any) =>
{
	return API.get('feedsManagement', '/indusFilter', { queryStringParameters });
};

export function updateReaction(body:any)
{
	return API.post('taskManagement', '/reaction', { body });
}
export function getReaction(queryStringParameters:any)
{
	return API.get('taskManagement', '/reaction', { queryStringParameters });
}
export function updateEventLikes(body:any)
{
	return API.post('taskManagement', '/recognitionLike', { body });
}

export const updateFeedConfigUsr = (body) =>
{
	return API.post('userManagement', '/socialAccount', { body });
};
export const getLinkPreviewD = (query) =>
{
	return axios.request({
		url    : `https://opengraph.io/api/1.1/site/${query}`,
		method : 'get',
		params : {
			app_id : process.env.REACT_APP_LINK_PREVIEW_KEY
		}

	});
};